import React from 'react';
import classes1 from './QuickView.css';
import { QuestionMarkIcon } from '../../../UI/Icons/Icons';
import * as actions from '../../../store/actions/index';
import { useDispatch, useSelector } from 'react-redux';

import {
    SESSION_BASELINEAGENT,
    SESSION_READONLYUSER,
    HSID_DELETED,
    HSID_BASE,
    LS_OTP_VERIFIED
} from '../../../shared/Constants';

import {
    isPartialRegistration,
    isBasicMemberAccount,
    isAccountDisabled,
    decodeBase64
} from '../../../shared/utility';

import Message from '../../../components/Message/Message';

const accountStatusQuickViewDiv = (props) => {

    const dispatch = useDispatch();

    const deleteAccountMsg = useSelector(
        (state) => state.member.deleteAccountMsg
    );

       const member = useSelector(
            (state) => state.member
        );

    const uuid = decodeBase64(localStorage.getItem(LS_OTP_VERIFIED));
    const memberEsso = props.member?.essoData;
    const userType = props.userType;

    const isDeleteDisabled =
        userType === SESSION_BASELINEAGENT ||
        props.idType === HSID_BASE ||
        isAccountDisabled(memberEsso);

    const doesRecoveryExist = () => {
        const es = props.member?.essoData;
        if (!es) return false;
        const phoneAvailable = !!(es.phone && es.phone.number);
        const securityQues = !!(es.credential && es.credential.securityQuestionAndAnswers && es.credential.securityQuestionAndAnswers.length);
        return phoneAvailable || securityQues;
    };

    const isRBALocked = () => {
        return !!(props.member?.essoData?.accountStatus && props.member.essoData.accountStatus.aaStatus);
    };

    const deleteAccountHandler = (event) => {
        if (event && event.preventDefault) event.preventDefault();
        if (!props.member) return;

        const member = props.member;
        const idType = props.idType;

        const uuidVal = member.healthSafeId ? member.healthSafeId : member.essoData?.uuid;
        const userName = member.essoData?.userName;

        let accountRecoveryRequest = null;
        let rbaLocked = false;

        if (isRBALocked() && doesRecoveryExist()) {
            rbaLocked = true;
            accountRecoveryRequest = {
                email: member.essoData?.email?.value,
                uuid: uuidVal,
                phoneAvailable: !!(member.essoData?.phone?.number),
                securityQues: !!(member.essoData?.credential && member.essoData.credential.securityQuestionAndAnswers),
                accStatus: member.essoData?.accountStatus?.aaStatus,
                userName: member.essoData?.userName,
                headless: !!props.isHeadlessUser
            };
        }

        const formData = {
            isRBALocked: rbaLocked,
            provisionMemberId: member.provisionMemberId || null,
            userName: userName,
            emailId: member.essoData?.email?.value,
            secondaryEmail: member.essoData?.secondaryEmail?.value,
            uuid: uuidVal,
            partialRegisterUser: isPartialRegistration(idType),
            accountRecoveryRequest: accountRecoveryRequest,
            baseHSID: isBasicMemberAccount(idType),
            firstName: member.mdmFirstNm,
            lastName: member.mdmLastNm,
            dob: member.mdmDob,
            portal: member.mbrRgstPrtlShrtNm,
            enterpriseId: member.mdmMemberEid,
            memberDBDeleted: props.idType === HSID_DELETED
        };

        dispatch(actions.deleteAccount(formData));
    };

    const onDeleteClick = (event) => {
        if (!isDeleteDisabled) {
            deleteAccountHandler(event);
        }
    };

    const showDeleteButton =
        !props.deleted &&
        props.idType === HSID_DELETED &&
        props.userType !== SESSION_READONLYUSER;

    return (
        props.shouldShow ? <div>

            <label>Account Status: </label>

            {props.deleted ? (
                <span>
                    <label style={{ backgroundColor: 'yellow' }}> Deleted </label>
                </span>
            ) : (
                props.isNullHSID ? '' : (
                    props.status === 'enabled' ? (
                        <span>
                            Enabled

                            {showDeleteButton && (
                                <span style={{ marginLeft: '6px' }}>
                                    <span className={isDeleteDisabled ? classes1.TrashDisableLinkCol : classes1.TrashLinkCol}>
                                        <i
                                            id="deleteAccountIcon"
                                            className="fa fa-trash"
                                            onClick={onDeleteClick}
                                        />
                                    </span>
                                </span>
                            )}
                        </span>
                    ) : props.status === 'disabled' ? (
                        <span>
                            <label style={{ backgroundColor: 'yellow' }}> Disabled </label>
                        </span>
                    ) : ''
                )
            )}

            {showDeleteButton && !deleteAccountMsg && (
                <div style={{ marginTop: '4px' }}>
                    <Message
                        msgType="Info"
                        info={{ message: "User is currently partially deleted" }}
                    />
                </div>
            )}

            {props.isNullHSID ? '' : (
                <>
                    <button
                        id="whyDisabledLabel"
                        onClick={props.toggleQuickView}
                        className={classes1.QuickViewWhyDisabled}
                    >
                        {props.status === 'disabled' ? "More Info" : ""}
                    </button>

                    <button
                        id="whyDisabledIcon"
                        className={classes1.whyDisabledIconQuestion}
                        onClick={props.toggleQuickView}
                    >
                        {props.status === 'disabled' ? <QuestionMarkIcon /> : ""}
                    </button>

                    <p
                        id="accountDisabledError"
                        className={classes1.QuickViewDisableInfo}
                    >
                        {props.whyDisabledReason}
                    </p>
                </>
            )}

            {deleteAccountMsg && (
                <div style={{ marginTop: '6px' }}>
                    <Message
                        msgType={deleteAccountMsg.type}
                        info={deleteAccountMsg}
                    />
                </div>
            )}

        </div> : ""
    );
};

export default accountStatusQuickViewDiv;